module.exports = __webpack_public_path__ + "static/media/next-arrow-circle.3b12881c.svg";